module.exports = __webpack_public_path__ + "img/card_250460828.d671358a.jpg";